module.exports = __webpack_public_path__ + "static/cta-bg-f3b383643d29d809b181c0aa6e10f498.png";